import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

var config = {
  apiKey: "AIzaSyBpsfYj5DOoB1Vd7PQaAGfXs-DTWXkvjZE",
  authDomain: "worldcup-9b583.firebaseapp.com",
  databaseURL: "https://worldcup-9b583.firebaseio.com",
  projectId: "worldcup-9b583",
  storageBucket: "worldcup-9b583.appspot.com",
  messagingSenderId: "558541719333"
};
firebase.initializeApp(config);

const storage = firebase.storage();
const db = firebase.firestore();
export {
  db, storage, firebase as default
}